import api from 'connections/api';

export async function getTodo() {
  try {
    const res = await api.get('/api/planner/todo/');
    return res.data;
  } catch (error) {
    console.error('Error fetching todo:', error);
    return [];
  }
}

export async function createTodo(todo) {
  try {
    const res = await api.post('/api/planner/todo/', todo);
    return res.data;
  } catch (error) {
    console.error('Error creating todo:', error);
    throw error;
  }
}

export async function updateTodo(id, todo) {
  try {
    const res = await api.patch(`/api/planner/todo/${id}/`, todo);
    return res.data;
  } catch (error) {
    console.error('Error updating todo:', error);
    throw error;
  }
}

export async function deleteTodo(id) {
  try {
    await api.delete(`/api/planner/todo/${id}/`);
  } catch (error) {
    console.error('Error deleting todo:', error);
    throw error;
  }
}

export async function createTodoItem({ text, todo, order }) {
  try {
    const res = await api.post('/api/planner/todoitems/', { text, todo, order, done: false });
    return res.data;
  } catch (error) {
    console.error('Error creating todo item:', error);
    throw error;
  }
}

export async function updateTodoItem(id, data) {
  try {
    const res = await api.patch(`/api/planner/todoitems/${id}/`, data);
    return res.data;
  } catch (error) {
    console.error('Error updating todo item:', error);
    throw error;
  }
}

export async function deleteTodoItem(id) {
  try {
    await api.delete(`/api/planner/todoitems/${id}/`);
  } catch (error) {
    console.error('Error deleting todo item:', error);
    throw error;
  }
}

export async function reorderTodo(todo_list) {
  try {
    const payload = todo_list.map(todo => ({
      id: todo.id,
      order: todo.order,
      column: todo.column
    }));

    await api.post('/api/planner/todo/reorder_todo/', payload);
  } catch (error) {
    console.error('Error reordering todo:', error);
    throw error;
  }
}

export async function toggleTodoExpanded(todoId) {
  try {
    const response = await api.patch(`/api/planner/todo/${todoId}/toggle_expanded/`);
    return response.data;
  } catch (error) {
    console.error('Error toggling todo expanded state:', error);
    throw error;
  }
}

export async function reorderTodoItems(todoId, items) {
  try {
    // Only send items with a valid numeric id (exclude placeholders / unsaved rows)
    const validItems = items
      .filter((item) => item != null && Number.isInteger(item.id))
      .map((item, idx) => ({ id: item.id, order: idx }));
    if (validItems.length === 0) return;
    const payload = { todo_id: todoId, items: validItems };
    const res = await api.post('/api/planner/todoitems/reorder_items/', payload);
    return res.data;
  } catch (error) {
    console.error('Error reordering todo items:', error);
    throw error;
  }
}
